import usePureState from '@/hooks/usePureState';
import businessHoursService from '@/services/businessHours.service';
import { IDayID } from '@/types/BusinessHours';
import { HStack, IconButton, Input } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { IoMdClose } from 'react-icons/io';

export interface IntervalProps {
	id: IDayID;
	index: number;
	start: string;
	end: string;
	onDeleteClick: (id: IDayID, index: number) => void;
	onStartChange: (id: IDayID, index: number, value: string) => void;
	onEndChange: (id: IDayID, index: number, value: string) => void;
	isLoading?: boolean;
}

export default function Interval(props: IntervalProps) {
	const { t } = useTranslation();
	const isInvalid = !businessHoursService.checkValidInterval(props);
	const { state, dispatch } = usePureState({
		start: props.start,
		end: props.end,
	});

	return (
		<HStack justifyContent="space-between" px="2" py="2">
			<HStack flex="1" maxW="220px">
				<Input
					isDisabled={props.isLoading}
					size="sm"
					value={state.start}
					onChange={(e) => dispatch({ start: e.target.value })}
					onBlur={(e) => props.onStartChange(props.id, props.index, e.target.value)}
					type="time"
					isInvalid={isInvalid}
				/>

				<Input
					isDisabled={props.isLoading}
					size="sm"
					value={state.end}
					onChange={(e) => dispatch({ end: e.target.value })}
					onBlur={(e) => props.onEndChange(props.id, props.index, e.target.value)}
					type="time"
					isInvalid={isInvalid}
				/>
			</HStack>

			<IconButton
				isDisabled={props.isLoading}
				ml="auto"
				variant="ghost"
				isRound
				onClick={() => props.onDeleteClick(props.id, props.index)}
				size="sm"
				aria-label={t('Delete interval')}
				title={t('Delete interval')}
				icon={<IoMdClose />}
			/>
		</HStack>
	);
}
